import React from 'react';
import { FISH_HEALTH, fishHealth } from "../../../../../util/varibles/constants";
import StickerFishHealth from "../../../../Location/FishHealth/StickerFishHealth";
import LineInfo from "../LineInfo";

interface IProps {
    value?: FISH_HEALTH | null
}

const FishHealthInfo: React.FC<IProps> = ({ value }) => {
    const { name = '-' } = fishHealth[value || ''] || {};

    return <LineInfo className="relative" label="Fish health" icon={name !== '-'}>
        <div>
            <div className="absolute top-[3px] left-[2px]">
                <StickerFishHealth value={value} />
            </div>
            {name}
        </div>
    </LineInfo>;
};

export default FishHealthInfo;
